// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Accordion/Media.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Accordion, AccordionItem, view, css} from '@sail/ui';
import {PanelExample} from './PanelExample';

const mediaIcon = (
  <svg
    height="32"
    width="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" fill="#e3e8ee" />
      <path
        d="M7.274 13.5a1.25 1.25 0 0 1-.649-2.333C7.024 10.937 10.15 9.215 16 6c5.851 3.215 8.976 4.937 9.375 5.167a1.25 1.25 0 0 1-.65 2.333zm12.476 10v-8.125h3.75V23.5H25a1 1 0 0 1 1 1V26H6v-1.5a1 1 0 0 1 1-1h1.5v-8.125h3.75V23.5h1.875v-8.125h3.75V23.5z"
        fill="#697386"
      />
    </g>
  </svg>
);
export const Media = () => {
  return (
    <view.div
      css={{
        background: 'surface',
        minWidth: css.value('500px'),
      }}
    >
      <Accordion>
        <AccordionItem
          media={mediaIcon}
          title="ACH credit transfer"
          subtitle="ACH Credit Transfer enables US customers to pay by sending funds directly to a US bank account."
        >
          <PanelExample />
        </AccordionItem>
        <AccordionItem
          title="Cards"
          subtitle="Accept Visa, Mastercard, American Express, Discover, Diners Club, and JCB payments from customers worldwide."
        >
          <PanelExample />
        </AccordionItem>
        <AccordionItem
          title="Apple Pay"
          subtitle="Manage Apple Pay domains and certificates."
        >
          <PanelExample />
        </AccordionItem>
      </Accordion>
    </view.div>
  );
};
